<template>
  <div class="page">
    <div class="box">
      <div class="item-box">
        <div class="item" v-for="(item, index) in pl" :key="index">
          <div class="header">
            <div class="flex">
              <div class="logo">
                <img :src="item.productLog" />
              </div>
              <div class="cpmc">{{ item.productName }}</div>
            </div>
            <div class="button" @click="toProductPoster(item.id)">赚取佣金</div>
          </div>
          <div class="body">
            <div class="left">
              <div class="left_con" v-show="item.maxLine">
                <div>
                  {{ item.maxLine }}
                </div>
                <div>最高额度(万元)</div>
              </div>
            </div>
            <div class="right">
              <div v-show="item.minRate && item.maxRate">
                <img
                  src="https://static.xchengtech.cn/8931f2a32acb40a0a3d54a2f79efbb5c.png"
                  alt=""
                />
                <span>年化利率：{{ item.minRate }} - {{ item.maxRate }}</span>
              </div>
              <div v-show="item.period">
                <img
                  src="https://static.xchengtech.cn/8931f2a32acb40a0a3d54a2f79efbb5c.png"
                  alt=""
                />
                <span>借款期限：{{ item.period }}</span>
              </div>
              <div v-show="item.repayment">
                <img
                  src="https://static.xchengtech.cn/8931f2a32acb40a0a3d54a2f79efbb5c.png"
                  alt=""
                />

                <span>还款方式：{{ item.repayment }}</span>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div v-show="item.advantage1">
              <img
                src="https://static.xchengtech.cn/0d5762559bce41608d9dcc6a70462041.png"
                alt=""
              />
              <span>{{ item.advantage1 }}</span>
            </div>
            <div v-show="item.advantage2">
              <img
                src="https://static.xchengtech.cn/0d5762559bce41608d9dcc6a70462041.png"
                alt=""
              />
              <span>{{ item.advantage2 }}</span>
            </div>
            <div v-show="item.advantage3">
              <img
                src="https://static.xchengtech.cn/0d5762559bce41608d9dcc6a70462041.png"
                alt=""
              />
              <span>{{ item.advantage3 }}</span>
            </div>
          </div>
        </div>
        <van-empty v-show="!pl[0]" description="无符合产品" />
      </div>
    </div>
    <div class="close" @click="close">
      <!-- <van-icon size="10vw" name="cross" /> -->
      <van-icon size="10vw" name="close" color="white" />
    </div>
    <van-dialog
      v-model="posterShow"
      v-if="posterShow"
      :overlayStyle="{ background: 'white' }"
      :style="{ height: '100%', width: '100%' }"
    >
      <poster :picList="picList"></poster>
    </van-dialog>
  </div>
</template>

<script>
import { getCurrentChannelInfo } from "@/api/login.js";
import { icon, Popup, Dialog, Toast, Empty } from "vant";

import { mapGetters } from "vuex";
import store from "@/store";
import { getProductPoster } from "@/api/product";
export default {
  computed: {
    ...mapGetters(["Login"]),
  },
  components: {
    [icon.name]: icon,
    [Popup.name]: Popup,
    [Popup.Empty]: Empty,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      posterShow: false,
      picList: [],
      channelInfo: {},
    };
  },
  created() {
    getCurrentChannelInfo().then((res) => {
      this.channelInfo = res;
    });
  },
  props: {
    pl: {
      type: Array,
      default: null,
    },
  },
  methods: {
    close() {
      this.$parent.$parent.result = false;
    },

    toProductPoster(id) {
      this.$router.push({
        path: "/productPoster",
        query: { productId: id, channelId: this.channelInfo.id },
      });
    },
    getUrl(id) {
      return (
        this.getDomain() +
        "?productId=" +
        id +
        "&channelId=" +
        this.channelInfo.id
      );
    },
    getDomain() {
      return "https://apply.xchengtech.cn/";
    },
  },
};
</script>

<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productFilter/module/productList/index.vue